import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  allItems: [],
  activeItem: {
    id: 0,
    // children: {},
  },
  refreshTime:null,
  refreshTimeAsset:null,
};

const itemSlice = createSlice({
  name: "Items",
  initialState,
  reducers: {
    saveActiveItem: (state, action) => {
      console.log(action);
      state.activeItem.id = action.payload.id;
    },
    saveAllItems: (state, action) => {
      state.allItems = action.payload;
    },
    setRefreshTime: (state, { payload }) => {
      state.refreshTime = payload;
    },
    setRefreshTimeAsset: (state, { payload }) => {
      state.refreshTimeAsset = payload;
    },
    resetStateItems:() => initialState, 
  },
});

// Two actions generated from the slice
export const { saveActiveItem, saveAllItems,resetStateItems,setRefreshTime,setRefreshTimeAsset } = itemSlice.actions;

// The reducer
export default itemSlice.reducer;
